// extracted by mini-css-extract-plugin
export default {"notebook-edit":"NotebookEdit_notebook-edit__3zQ7Q"};